@let subHeader = subHeader$ | async;
@let items = items$ | async;
@let loading = loading$ | async;

<div class="mcm-metric-detail-container">
  <mcm-metric-detail-header
    [title]="metricToDetailed?.metricKey"
    (closeModal)="close()" />
  <ion-content>
    <div class="mcm-metric-detail-container__content">
      <mcm-metric-detail-sub-header [subHeader]="subHeader" />
      @if (loading) {
        <div class="mcm-metric-detail-container__loader">
          <mcm-loader [loading]="true" />
        </div>
      } @else {
        @for (item of items; track item.id) {
          @if (item.isDual) {
            <mcui-metric-item
              [gradientAccent]="true"
              [title]="item.text | translate"
              [leftValue]="item.leftValue"
              [leftUnit]="item?.leftUnit | translate"
              [rightValue]="item.rightValue"
              [rightUnit]="item?.rightUnit | translate" />
          } @else {
            <mcm-metric-detail-item
              [item]="item"
              [lang]="currentLang()" />
          }
        }
      }
    </div>
  </ion-content>
</div>
